import { useState } from 'react';
import { useTranslation } from "react-i18next";
import AddShopModal from './components/AddShopModal';
import Page from '@components/Page/Page';
import StoreTab from './tabs/StoreTab.tsx';
import { Button, ButtonSize } from "@components/new/Button";
import IconPlus from '@assets/icons/outline/plus.svg?react';
import styles from './StoresPage.module.scss';

const StoresPage = () => {
  const { t } = useTranslation();
  const [isOpenAddModal, setOpenAddModal] = useState<boolean>(false);

  return (
    <Page
      title={t('storesPage.title')}
      description={t('storesPage.description')}
    >
      <div className={styles.actions}>
        <Button
          size={ButtonSize.M}
          onClick={() => setOpenAddModal(true)}
          title={t('storesPage.addShop')}
          icon={IconPlus}
        />
      </div>

      <StoreTab openAddModal={() => setOpenAddModal(true)} />

      {isOpenAddModal ? (
        <AddShopModal
          onClose={() => {
            setOpenAddModal(false);
          }}
        />
      ) : null}
    </Page>
  );
};

export default StoresPage;
